/// <amd-module name="Artifacts/FeedPicker/services/FeedPickerService" />
import * as Constants from "Artifacts/Root/Constants";
import { loadData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { IFeedIdentity } from "Artifacts/Root/types";
import { ArtifactsFeed, FeedListData } from "Artifacts/Root/types/AzureArtifacts";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IFeedPickerData {
  feeds: IFeedIdentity[];
  deletedFeeds: IFeedIdentity[];
}

export interface IFeedPickerService extends IVssService {
  getFeedPickerData(context: IVssPageContext): Promise<IFeedPickerData>;
}

export class FeedPickerService extends VssService implements IFeedPickerService {
  async getFeedPickerData(context: IVssPageContext): Promise<IFeedPickerData> {
    const data = await loadData<FeedListData>(
      context,
      "ms.azure-artifacts.feed-picker-data-provider",
      undefined,
      false,
      Constants.CommonConstants.FeedServiceInstanceId,
    );

    const feedPickerData: IFeedPickerData = {
      feeds: data?.feeds.map(mapToIFeedIdentity) || [],
      deletedFeeds: data?.deletedFeeds.map(mapToIFeedIdentity) || [],
    };

    return feedPickerData;
  }
}

function mapToIFeedIdentity(feed: ArtifactsFeed): IFeedIdentity {
  return {
    id: feed.id,
    name: feed.name,
    project: feed.project || undefined,
  } as IFeedIdentity;
}

Services.add("IFeedPickerService", { serviceFactory: FeedPickerService });
